import type { ReactNode } from "react";
import { Inbox, type LucideIcon } from "lucide-react";
import { cx } from "./cx.js";

export interface EmptyStateProps {
  title: string;
  message?: ReactNode;
  /** Pass null to omit the default decorative icon. */
  icon?: LucideIcon | null;
  /** The ONE next action (button or link), if any. */
  action?: ReactNode;
  compact?: boolean;
}

export function EmptyState({ title, message, icon, action, compact = false }: EmptyStateProps) {
  const Icon = icon === undefined ? Inbox : icon;
  return (
    <div className={cx("empty-state", compact && "empty-state--compact")} role="status">
      {Icon ? <Icon className="empty-state__icon" aria-hidden /> : null}
      <div className="empty-state__title">{title}</div>
      {message ? <div className="empty-state__message">{message}</div> : null}
      {action ? <div className="empty-state__action">{action}</div> : null}
    </div>
  );
}
